import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { FormattedMessage } from 'react-intl'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace'
import moment from 'moment'
import {
  ListItem,
  ListItemAvatar,
  Icon,
  ListItemText,
  DialogTitle,
  Dialog,
  DialogContent,
} from '@material-ui/core'
import PersonAvatar from '../PersonAvatar'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#0073b1',
    color: 'white',
    padding: '0',
    minWidth: '345px',
  },
  subTitleStyle: {
    color: '#a8a8a8',
    padding: ' 0 2rem',
    fontSize: 'smaller',
    minWidth: '345px',
    overflow: 'hidden !important',
  },
  dialogContentStyle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'end',
    padding: '3rem',
  },
  backSpaceIconStyle: {
    marginRight: '1rem',
    cursor: 'pointer',
    color: 'white',
    fontSize: 'initial',
  },
  subscriberitem: {
    display: 'flex',
    alignItems: 'center',
    margin: '0.7rem',
    color: 'grey',
    '& :first-child': {
      fontSize: '2rem',
      marginRight: '1rem',
    },
  },
  bDataText: {
    fontWeight: '100',
    color: '#0073b1',
    marginLeft: '1rem',
    fontSize: 'smaller',
    fontStyle: 'oblique',
  },
  avatarIcon: {
    fontWeight: '100',
    fontSize: '16px',
  },
}))

const SubscribersDetail = ({ open, subscriberData, handleCloseModal }) => {
  const classes = useStyles()

  const getDaysForCommingBirthDay = () => {
    let currentDayAndMonth = moment().format('MM-DD')
    let currentData = moment().format('YYYY-MM-DD')
    let amountOfBirthDay = 0,
      birthData = 0
    if (subscriberData) {
      let birthMonth = moment(subscriberData.birthday).format('MM-DD')
      birthData = moment(subscriberData.birthday).set(
        'year',
        parseInt(moment().format('YYYY')),
      )
      amountOfBirthDay = birthData.diff(currentData, 'days')

      if (currentDayAndMonth > birthMonth) {
        birthData = moment(subscriberData.birthday).set(
          'year',
          parseInt(moment().format('YYYY')) + 1,
        )
        amountOfBirthDay = birthData.diff(currentData, 'days')
      }
    }
    return amountOfBirthDay
  }

  return (
    <Dialog open={open} aria-labelledby="subscriber-data">
      <DialogTitle id="subscriber-data" className={classes.root}>
        {subscriberData && (
          <ListItem>
            <KeyboardBackspaceIcon
              className={classes.backSpaceIconStyle}
              onClick={handleCloseModal}
            />
            <ListItemAvatar>
              <PersonAvatar
                placeHolder={subscriberData && subscriberData.avatarCharacters}
                subId={subscriberData.id}
                alt={subscriberData.firstName}
                src={subscriberData.profilePicture}
                className={classes.avatarIcon}
              />
            </ListItemAvatar>
            <ListItemText
              primary={`${subscriberData.firstName} ${subscriberData.lastName}`}
            />
          </ListItem>
        )}
      </DialogTitle>
      {subscriberData && (
        <DialogContent className={classes.dialogContentStyle}>
          {subscriberData.email && (
            <span className={classes.subscriberitem}>
              <Icon>email</Icon>
              {subscriberData.email}
            </span>
          )}
          {subscriberData.phoneNumber && (
            <span className={classes.subscriberitem}>
              <Icon>phone</Icon>
              {`${subscriberData.countryCode} ${subscriberData.phoneNumber}`}
            </span>
          )}
          {subscriberData.automatedCallPhoneNumber && (
            <span className={classes.subscriberitem}>
              <Icon>phone</Icon>
              {`${subscriberData.automatedCallCountryCode} ${subscriberData.automatedCallPhoneNumber}`}
            </span>
          )}
          {subscriberData.birthday && (
            <span className={classes.subscriberitem}>
              <Icon>cake</Icon>
              <span>{moment(subscriberData.birthday).format('LL')}</span>
              <span className={classes.bDataText}>
                {getDaysForCommingBirthDay() === 0 ? (
                  <FormattedMessage id="metrics.birthday.today.text" />
                ) : (
                  <FormattedMessage
                    id="metrics.birthday.text"
                    values={{ day: getDaysForCommingBirthDay() }}
                  />
                )}
              </span>
            </span>
          )}
        </DialogContent>
      )}
    </Dialog>
  )
}

export default SubscribersDetail
